import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { hasRestrictedAccess, isPageAllowed, subscriptionLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (subscriptionLoading) return; // Don't redirect while loading

    if (hasRestrictedAccess()) {
      if (!isPageAllowed(location.pathname)) {
        // Redirect to profile page with a message about restricted access
        navigate('/profile/edit?tab=subscription&restricted=true', { replace: true });
      }
    }
  }, [hasRestrictedAccess, isPageAllowed, location.pathname, navigate, subscriptionLoading]);

  // Show loading while checking subscription status
  if (subscriptionLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500 mx-auto"></div>
          <p className="mt-2 text-sm text-gray-600">Checking access permissions...</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;